<template>
	<div>
		<ValidationObserver ref="form">
			<b-form-group>
				<ValidationProvider rules="required" v-slot="{ errors }">
					<b-form-radio-group
						v-model="action"
						@change="rows.map((row) => ((row.reason = null), (row.behavior = false)))"
						:options="[
							{ text: 'Muerto', value: 1 },
							{ text: 'Depurar', value: 2 },
						]"
					/>
					<small class="text-danger" v-if="errors.length > 0">{{ errors[0] }}</small>
				</ValidationProvider>
			</b-form-group>
			<b-table-simple class="mt-2 table-bordered" small sticky-header="80vh">
				<b-thead class="text-center">
					<b-tr>
						<b-th>Ejemplar</b-th>
						<b-th>Razon</b-th>
						<b-th>Fecha</b-th>
						<b-th>Evidencia</b-th>
						<b-th>Acciones</b-th>
					</b-tr>
				</b-thead>
				<b-tbody class="text-center">
					<b-tr v-for="(row, idx) in rows" :key="idx">
						<b-td>
							<ValidationProvider
								rules="required"
								v-slot="{ errors }"
								class="d-flex justify-content-center"
							>
								<v-select
									label="query"
									style="width: 15rem"
									:class="{ 'border-danger rounded': !!errors[0] }"
									:clearable="false"
									multiple
									:options="specimenOpts"
									:reduce="specimenReducer"
									:selectable="checkOptionSelectable"
									:getOptionKey="(opt) => `${opt.id}-${opt.chick_id}`"
									v-model="row.specimens"
									appendToBody
									:calculatePosition="positionDropdown"
									@search="fetchOpts"
									@option:selecting="handleSpecimenSelected"
								>
									<template #option="opt">
										<span>{{ opt.alias || "---" }} / ({{ opt.plate }})</span>
									</template>

									<template #selected-option="opt">
										<span>{{ opt.alias || "---" }} / ({{ opt.plate }})</span>
									</template>
								</v-select>
							</ValidationProvider>
						</b-td>
						<b-td>
							<ValidationProvider rules="required" v-slot="{ errors }">
								<v-select
									label="reason"
									style="min-width: 15rem"
									:class="{ 'border-danger rounded': !!errors[0] }"
									:options="action == 1 ? deadReasonOpts : depurationReasonOpts"
									:clearable="false"
									:reduce="(option) => option.id"
									v-model="row.reason"
									appendToBody
									:calculatePosition="positionDropdown"
								>
									<template v-slot:option="option">
										<div class="d-flex justify-content-between">
											<span :class="{ 'pl-2': !!option.parent_id }">
												{{ option.reason }}
											</span>
											<!-- <span v-if="option.parent_id">
												Sub-motivo de {{ option.parent_reason }}
											</span> -->
										</div>
									</template>
								</v-select>
							</ValidationProvider>
							<!-- Para pelea (20) y chusca (21) -->
							<div class="pt-1" v-if="action == 1 && [20, 21].includes(row.reason)">
								<small style="padding-left: 0.2rem">Corrido: {{ row.behavior ? "SI" : "NO" }}</small>
								<b-form-checkbox v-model="row.behavior" class="d-inline ml-1" switch />
							</div>
						</b-td>
						<b-td>
							<ValidationProvider rules="required" v-slot="{ errors }">
								<flat-pickr
									class="form-control bg-transparent"
									:class="{ 'border-danger is-invalid': !!errors[0] }"
									style="min-width: 10rem"
									v-model="row.date"
								/>
								<small class="text-danger" v-if="errors.length != 0">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-td>
						<b-td>
							<ValidationProvider rules="required" v-slot="{ errors }">
								<b-button
									class="btn-icon"
									:class="{ 'border-danger rounded': !!errors[0] }"
									variant="flat-secondary"
									@click="row.useEvidence = true"
									v-if="!row.useEvidence"
								>
									<feather-icon icon="PlusIcon" size="20" />
								</b-button>
								<div
									class="d-flex justify-content-center align-items-center gap-x-2"
									style="min-width: 10rem"
									v-else
								>
									<ShowAndUploadImg v-model="row.evidence" />
									<b-button class="btn-icon" variant="flat-danger" @click="hideEvidence(idx)">
										<feather-icon icon="TrashIcon" size="20" @click="row.useEvidence = true" />
									</b-button>
								</div>
							</ValidationProvider>
						</b-td>
						<b-td>
							<b-button
								class="btn-icon"
								size="sm"
								variant="danger"
								@click="deleteRow(idx)"
								:disabled="rows.length < 2"
							>
								<feather-icon icon="TrashIcon" />
							</b-button>
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
			<div class="d-flex justify-content-end">
				<b-button class="btn-icon" size="sm" variant="outline-success" @click="addRow">
					<feather-icon icon="PlusIcon" size="20" />
				</b-button>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
import _ from "lodash"
import moment from "moment"
import { getBase64 } from "@/helpers/functions"
import deadsService from "@/services/deads.service"
import reasonsService from "@/services/reasons.service"

import ShowAndUploadImg from "./ShowAndUploadImg.vue"

export default {
	components: { ShowAndUploadImg },
	props: {
		saveTrigger: Symbol,
	},
	data: () => ({
		action: 1,
		rows: [],
		//
		specimenOpts: [],
		selectedSpecimens: [],
		deadReasonOpts: [],
		depurationReasonOpts: [],
		//
	}),
	methods: {
		async getDeadOpts() {
			this.$emit("loading", true)
			const reasons = await reasonsService.getByModule(1, 3)
			this.deadReasonOpts = reasons.filter((r) => r.reason != "SELECCIÓN")
			this.depurationReasonOpts = reasons

			this.$emit("loading", false)
		},

		// async getDepurationOpts() {
		// 	this.$emit("loading", true)
		// 	const reasons = await reasonsService.getByModule(1, 21)
		// 	this.depurationReasonOpts = reasons

		// 	this.$emit("loading", false)
		// },

		resetAll() {
			this.rows = []
			this.specimenOpts = []
			this.selectedSpecimens = []
			this.$refs.form.reset()
		},
		addRow() {
			this.rows.push({
				specimens: [],
				reason: null,
				date: null,
				useEvidence: false,
				evidence: [],
				behavior: false,
			})
		},
		deleteRow(idx) {
			this.rows.splice(idx, 1)
		},
		positionDropdown(dropdownList, component, { width, top, left }) {
			dropdownList.style.zIndex = 9999
			dropdownList.style.maxHeight = "20rem"
			dropdownList.style.top = top
			dropdownList.style.left = left
			dropdownList.style.width = width
		},
		// search
		fetchOpts(search, loading) {
			this.findSpecimens(search, loading, this.setOpts)
		},
		findSpecimens: _.debounce(async (search, loading, setter) => {
			loading(true)
			const { data } = await deadsService.getSpecimens({ search })
			// para que el search del select tenga un campo para buscar por placa y alias a la vez
			const fixedData = data.map((opt) => ({ ...opt, query: opt.plate + "," + opt.alias }))
			setter(fixedData)
			loading(false)
		}, 500),
		setOpts(data) {
			const existingIds = this.selectedSpecimens.map((opt) => opt.id)
			const withoutDuplicateds = data.filter((opt) => !existingIds.includes(opt.id))
			this.specimenOpts = [...withoutDuplicateds, ...this.selectedSpecimens]
		},
		handleSpecimenSelected(specimen) {
			if (specimen.id === 0) {
				// el ejemplar esta en 'Nuevos Ejemplares'
				// specimen.id = specimen.chick_id
				this.selectedSpecimens.push(specimen)
				return
			}
			const existingIds = this.selectedSpecimens.map((opt) => opt.id)
			if (existingIds.includes(specimen.id)) return
			this.selectedSpecimens.push(specimen)
		},
		async hideEvidence(idx) {
			const row = this.rows[idx]
			if (row.evidence.length != 0) {
				const { isConfirmed } = await this.showConfirmSwal({
					text: `Se borraran las imagenes de evidencia seleccionadas`,
				})
				if (!isConfirmed) return
				row.evidence = []
			}
			row.useEvidence = false
		},
		async save() {
			try {
				if (!(await this.$refs.form.validate())) return
				// Calcular total de especímenes seleccionados
				const totalSpecimens = this.rows.reduce((sum, row) => sum + (row.specimens?.length || 0), 0)
				const { isConfirmed } = await this.showConfirmSwal({
					title: `Se registrara ${totalSpecimens} ejemplar(es) como ${
						this.action == 1 ? "MUERTO" : "DEPURADO"
					}`,
				})
				if (!isConfirmed) return
				this.$emit("loading", true)
				const groups = []
				console.l
				for (let i = 0; i < this.rows.length; i++) {
					const row = this.rows[i]

					// Obtener los IDs de los especímenes seleccionados
					const specimen_ids = []
					const chick_ids = []

					for (const specimenId of row.specimens) {
						const fullSpecimen = this.selectedSpecimens.find(
							(s) => s.id == specimenId || s.chick_id == specimenId
						)
						if (!fullSpecimen) throw Error("Ejemplar no encontrado en opciones")

						if (fullSpecimen.id === 0) {
							// Es un nuevo ejemplar (chick)
							chick_ids.push(fullSpecimen.chick_id)
						} else {
							specimen_ids.push(fullSpecimen.id)
						}
					}

					// images
					let images = []
					for (let idx = 0; idx < row.evidence.length; idx++) {
						const img = row.evidence[idx]
						let base = undefined
						if (img.id == null) {
							base = await getBase64(img.file)
						}
						images.push({ base })
					}
					//
					groups.push({
						specimen_ids,
						chick_ids,
						reason_id: row.reason,
						date_dead: moment(row.date).format("YYYY-MM-DD"),
						images,
						corrido: row.behavior ? 2 : null,
					})
				}
				await deadsService.insertDeadSpecimens({ specimens: groups, is_depuration: this.action == 2 })
				this.showToast("success", "top-right", "Muertos", "CheckIcon", "Guardado con exito")
				this.resetAll()
			} catch (error) {
				console.error(error)
			} finally {
				this.$emit("loading", false)
			}
		},
		checkOptionSelectable(opt) {
			// Recopilar todos los IDs ya seleccionados en todos los rows
			const existingIds = this.rows.flatMap((row) => row.specimens || [])

			if (opt.id === 0) {
				// el ejemplar esta en 'Nuevos Ejemplares'
				if (existingIds.includes(opt.chick_id)) return false
				return true
			}

			if (existingIds.includes(opt.id)) return false
			return true
		},
		specimenReducer(opt) {
			if (opt.id === 0 && opt.chick_id != null) {
				// cuando es una opcion de 'Nuevos Ejemplares'
				return opt.chick_id
			}
			return opt.id
		},
	},
	created() {
		this.getDeadOpts()
		// this.getDepurationOpts()
		this.addRow()
	},
	watch: {
		saveTrigger(val) {
			this.save()
		},
	},
}
</script>
